import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { STATUS } from "state/requestStatus/reducer";
import MarkdownEditor from 'components/interactive/markdown/MarkdownEditor';

const ContrainWidth = styled.div`
  max-width: 100%;
  margin-top: 20px;
`;

class AnnotationEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.text,
      annotationId: props.annotationId,
    };
  }

  getAnnotation = (props) => {
    const { annotations, pageId, userId } = this.props;
    const key = `${pageId}#${userId}`;
    const annoData = annotations[key];
    return annoData;
  }

  saveAnnotation = (event) => {
    event.preventDefault();
    const { store } = this.context;
    const { pageId, userId, annotationId, sectionId } = this.props;
    if (this.props.annotationId) {
      store.dispatch({
        type: "UPDATE_ANNOTATION_REQUESTED",
        payload: {
          pageId: pageId,
          userId: userId,
          annotationId: annotationId,
          sectionId: sectionId,
          text: this.state.text,
        }
      });
    } else {
      store.dispatch({
        type: "CREATE_ANNOTATION_REQUESTED",
        payload: {
          pageId: pageId,
          userId: userId,
          sectionId: sectionId,
          text: this.state.text,
        }
      });
    }
  }

  handleInputChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  handleEditorChange = (value) => {
    this.setState({ text: value });
  }

  componentWillReceiveProps(nextProps) {
    const annoData = this.getAnnotation(nextProps);
    if (annoData.status === STATUS.COMPLETE) {
      this.props.onCancel();
    }
  }

  render () {
    return (
      <ContrainWidth>
        <form onSubmit={this.saveAnnotation}>
          <MarkdownEditor value={this.state.text} onChange={this.handleEditorChange} />
          <div>
            <button onClick={this.props.onCancel}>Cancel</button>
            <button action="submit">Save</button>
          </div>
        </form>
      </ContrainWidth>
    );
  }
}

AnnotationEdit.contextTypes = {
  store: PropTypes.object
};

AnnotationEdit.propTypes = {
  pageId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  annotationId: PropTypes.string,
  text: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const user = state.user.data || {};
  const { annotations } = state;
  return { user, annotations };
}

export default connect(mapStateToProps, {})(withRouter(AnnotationEdit));




// WEBPACK FOOTER //
// ./src/components/interactive/annotation/AnnotationEdit.js